import React, { useState } from "react";

import { Route, Routes, useLocation } from "react-router-dom";

import CircularProgress from '@mui/material/CircularProgress';

// core components
import Card from "@mui/material/Card";

import { Helmet } from 'react-helmet'
import OthelloTituloPanelData from "../componentsothello/OthelloTituloPanelData";

export default function CondicionesInfoPage({ ...props }) {

    const { literal } = props;

    const [loading, setLoading] = React.useState(true);
    const [info, setinfo] = React.useState(null);
    const [tipo, settipo] = React.useState(null);

    const { search } = useLocation();

    React.useEffect(() => {

        let url = search;
        let params = new URLSearchParams(url);
        let tipoinfo = "";

        if (params.has('tipo'))
            tipoinfo = params.get('tipo');

        settipo(tipoinfo);
        setLoading(false);

        getDataPage(tipo);

    }, [loading]);


    const getDataPage = (tipoinfo) => {

        if (tipoinfo != null && (tipoinfo == "U" || tipoinfo == "C" || tipoinfo == "D" || tipoinfo == "P")) {
            var jsonData = JSON.stringify(tipoinfo);

            fetch('api/Data/GetInfoPoliticaReservar', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res =>
            {
                //Si se ha recibido un ok
                if (res != null)
                    setinfo(res);                    

            }).catch(error => {
            });
        }
    }

    let rescargando = loading ? <p><CircularProgress color="secondary" /></p> : "";

    let nombre = "";
    let infoshow = "";

    if (tipo == "C")
        nombre = "Politica de Cookies";
    else if (tipo == "U")
        nombre = "Condiciones de Uso";
    else if (tipo == "D")
        nombre = "Politica de Cancelacion";
    else if (tipo == "P")
        nombre = "Politica de Privacidad";

    infoshow = info != null ? info.info : ""

    if (infoshow != null && infoshow != "")
        infoshow = infoshow.split("\n").map((i, key) => { return <div key={key}>{i}</div>; });

    return (
        <div >
            <Helmet>
                <title>{!loading ? nombre : "Condiciones"}</title>
            </Helmet>
            {rescargando}
            <div>
                <center><h1>{!loading ? nombre : ""}</h1></center>
            </div>
            <OthelloTituloPanelData titulo={nombre}>                
                <div style={{ backgroundColor: '#FFFFFF' }}>
                    {infoshow}
                </div>
            </OthelloTituloPanelData>
        </div>);
}

